var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pie-container"},[_c('div',[_c('canvas',{ref:"chart",attrs:{"height":_vm.height}})]),(_vm.kind === 'doughnut')?_c('div',{staticClass:"chart-center"},[_vm._t("default")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }